import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModuleDocumentHelperService } from '../../../../../shared-components/src/lib/services/module-document-helper.service';
import { CourseType, LearnModule } from '@cna/projects/ak-jura/shared/interfaces';
import { UUID } from '@cna/shared/generic-types';

@Component({
    selector: 'cna-module-tile',
    templateUrl: './module-tile.component.html',
    styleUrls: ['./module-tile.component.scss'],
})
export class ModuleTileComponent {
    @Input()
    public learningModuleInfo: LearnModule;
    @Input()
    public courseType: CourseType;
    @Input()
    public mayAccessLearning: { allowed: boolean; reason?: string } | undefined;

    @Output()
    private selectModule = new EventEmitter<{ moduleId: UUID }>();
    @Output()
    private printModule = new EventEmitter<{ moduleId: UUID }>();

    CourseType = CourseType;

    protected get courseTypeDescription(): string {
        switch (this.courseType) {
            case CourseType.EducationCourse:
                return 'Lehrgang';
            case CourseType.TrainingCourse:
                return 'Fortbildung';
            default:
                return 'Kurs';
        }
    }

    constructor(
        public moduleDocumentHelperService: ModuleDocumentHelperService
    ) {}

    navigateOverview() {
        this.selectModule.emit({ moduleId: this.learningModuleInfo.id });
    }

    onPrintModule(event) {
        event.stopPropagation();
        this.printModule.emit({ moduleId: this.learningModuleInfo.id });
    }
}
